// extracted by mini-css-extract-plugin
export default {"text":"packageFlightInfo-module__text__ySuCf","link":"packageFlightInfo-module__link__xVFLT"};